const base = {
  proxy: '/apis' // 设置的代理  @config/index/proxyTable
}

export default base



// WEBPACK FOOTER //
// ./src/api/base.js